export const settingsPermissions = ['meta_capi_manage'];

export const customRolePermissions = [
  {
    label: 'META_CAPI',
    permissions: ['meta_capi_manage'],
  },
];
